// @file header scrolling
import { throttle } from 'lodash'

let container: HTMLElement
let header: HTMLElement

const moveHeader = throttle((): void => {
  header.style.marginLeft = `${container.scrollLeft}px`
}, 10)

function listenScrollHeader(containerEl: HTMLElement, headerEl: HTMLElement): void {
  container = containerEl
  header = headerEl
  container.addEventListener('scroll', moveHeader)
}

function unlistenScrollHeader(): void {
  if (!container) return
  container.removeEventListener('scroll', moveHeader)
}

export { listenScrollHeader, unlistenScrollHeader }
